import React from "react";
import { useRoutes } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import { CacheProvider } from "@emotion/react";

import { ThemeProvider as MuiThemeProvider } from "@mui/material/styles";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";

import createTheme from "./theme";
import routes from "./routes";
import createEmotionCache from "./utils/createEmotionCache";
import PasswordProtectedGuard from "@/guards/PasswordProtectedGuard";
import { TenantFeConfigProvider } from "@/contexts/TenantFeConfigContext";

const clientSideEmotionCache = createEmotionCache();

function App({ emotionCache = clientSideEmotionCache }) {
  const content = useRoutes(routes);

  return (
    <CacheProvider value={emotionCache}>
      <HelmetProvider>
        {/* <Helmet
          titleTemplate="%s | SWiiFT Engagement Platform"
          defaultTitle="SWiiFT Engagement Platform"
        /> */}
        {/* @ts-ignore */}
        <LocalizationProvider dateAdapter={AdapterDateFns}>
          <MuiThemeProvider theme={createTheme("DEFAULT")}>
            <TenantFeConfigProvider>
              <PasswordProtectedGuard>{content}</PasswordProtectedGuard>
            </TenantFeConfigProvider>
          </MuiThemeProvider>
        </LocalizationProvider>
      </HelmetProvider>
    </CacheProvider>
  );
}

export default App;
